export default {
      id: "mute-usage",
      viewBox: "0 0 566 566",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#mute",
      toString: function () {
        return this.url;
      }
    }